import React from 'react';
import Divider from 'components/Divider';
import Heading from 'components/Heading';
import Text from 'components/Text';
import Row from 'components/Row';

export type Props = {
  firstName?: string;
  hasUpcomingSessions: boolean;
};

export default function CoachingHomeWelcomeHeader(props: Props) {
  return (
    <>
      <Row size="xsmall">
        <Heading level="1" serif flush>
          Welcome, {props.firstName}
        </Heading>
      </Row>
      <Text size="medium" color="graphite">
        {props.hasUpcomingSessions
          ? 'Get ready for the upcoming session!'
          : 'Whether your child is tackling a tough assignment or needs extra practice for a test, we’re here to help.'}
      </Text>
      <Divider size="xxxlarge" />
    </>
  );
}
